import React from 'react';
import PropTypes from 'prop-types';
import { LargeMobile } from 'Responsive';
import CalculatorInput from 'CalculatorInput';
import TotalView from './TotalView';

const AssetsInputs = props => (
  <React.Fragment>
    <CalculatorInput
      title="Money in the bank"
      description={'Additional cash in the bank on top of the money you will use to cover monthly expenses that can be used as a safety net or to cover expenses that might come up in the first few months of starting a business.'}
      onChange={e => props.onChange(e, 0)}
      value={props.values[0]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Inventory"
      description={'Inventory you have at the start of the business (doesn’t apply to service businesses).'}
      onChange={e => props.onChange(e, 1)}
      value={props.values[1]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Equipment"
      description={'Equipment you have before opening your doors (purchase price of land, office furniture, etc.).'}
      onChange={e => props.onChange(e, 2)}
      value={props.values[2]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Other Assets"
      description=""
      onChange={e => props.onChange(e, 3)}
      value={props.values[3]}
      className="startup-calculator-input-wrap startup-calculator-final-input"
      type="monetary"
    />
    <LargeMobile>
      <TotalView
        title="Total Assets"
        sum={props.sum}
        back={props.back}
        next={props.next}
        backText="Expenses"
        nextText="Recurring Costs"
      />
    </LargeMobile>
  </React.Fragment>
);

AssetsInputs.defaultProps = {
  back: null,
  next: null,
};

AssetsInputs.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  sum: PropTypes.string.isRequired,
  back: PropTypes.func,
  next: PropTypes.func,
};

export default AssetsInputs;



// WEBPACK FOOTER //
// ./src-react/StartupCalculator/components/AssetsInputs.jsx